import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'rsuite';

export default props => <Dropdown.Item componentClass={Link} {...props} />;
